module.exports = __webpack_public_path__ + "static/media/Rubik-Medium.da0a01ed.woff";